import React from "react";

import CreateRows from "./CreateRows";

import TableFooter from "@material-ui/core/TableFooter";

export default class extends React.Component {
  render() {
    return (
      <TableFooter>
        <CreateRows {...this.props} />
      </TableFooter>
    );
  }
}
